import { render, staticRenderFns } from "./CompanyEmployeeQuickAddInfoDialog.vue?vue&type=template&id=378f80c2"
import script from "./CompanyEmployeeQuickAddInfoDialog.vue?vue&type=script&lang=js"
export * from "./CompanyEmployeeQuickAddInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports